export const BRAINTREE_CLIENT_AUTHORIZATION =
  process.env.REACT_APP_BRAINTREE_CLIENT_AUTHORIZATION || '';

export const PAYMENT_SUCCESS = 'token';
export const PAYMENT_ERROR = 'error';
export const PAYMENT_CANCEL = 'cancel';
